export default function ContactHero() {
  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-brand-800 via-brand-700 to-brand-600">
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='40' cy='40' r='1.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="absolute right-0 top-0 w-[45%] h-full hidden lg:block">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-brand-800/30 to-brand-700/90"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20customer%20support%20team%20in%20a%20bright%20contemporary%20Indian%20office%2C%20diverse%20team%20members%20smiling%20and%20engaged%20in%20conversation%20over%20a%20clean%20desk%20with%20a%20laptop%20and%20phone%20headset%2C%20warm%20natural%20lighting%20through%20large%20windows%2C%20professional%20but%20approachable%20atmosphere%2C%20soft%20focus%20background%20with%20collaborative%20office%20space%2C%20editorial%20corporate%20photography%20style%2C%20genuine%20friendly%20expressions%2C%20clean%20and%20minimal%20composition&width=900&height=800&seq=freshhlock-contact-hero-01&orientation=portrait"
          alt="Freshhlock support team ready to help"
          className="w-full h-full object-cover opacity-18"
        />
      </div>

      <div className="container-page relative z-10">
        <div className="flex flex-col lg:flex-row items-center min-h-[440px] md:min-h-[500px] py-16 md:py-20">
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-500/40 border border-secondary-400/30 mb-6">
              <div className="w-2 h-2 rounded-full bg-secondary-300"></div>
              <span className="text-xs font-medium text-secondary-100 uppercase tracking-widest">
                Get in Touch
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-5xl font-bold text-paper-50 leading-tight mb-5 text-balance">
              Let&apos;s Talk About Your Cold Chain
            </h1>
            <p className="text-base md:text-lg text-brand-100/80 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Whether you&apos;re a warehouse operator, transport partner, wholesale buyer, or a consumer — we have a team ready to help you make the most of Freshhlock.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="#contact-form"
                className="px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Send a Message
              </a>
              <a
                href="#departments"
                className="px-8 py-3.5 border border-brand-300/50 hover:border-paper-50/80 text-paper-50 font-medium text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Find Your Team
              </a>
            </div>
          </div>
          <div className="hidden lg:block w-2/5"></div>
        </div>
      </div>
    </section>
  );
}